import ToggleButton from "../toggle-button";
import style from "../mindmapOrientationPicker.module.css";
import { OrgChartOrientation } from "shared/datamodel/schemas/org-chart";
import { mindmapHorizontalOrientation, mindmapVerticalOrientation } from "../toolbar-design-system";
import tracking from "frontend/tracking";
import consts from "shared/consts";
import { useAtomValue } from "jotai";
import { boardAtom, userAtom } from "state-atoms";

export default function OrgchartOrientationPicker({
  value,
  onChange,
}: {
  value: OrgChartOrientation;
  onChange: (orientation: OrgChartOrientation) => void;
}) {
  const board = useAtomValue(boardAtom);
  const user = useAtomValue(userAtom);

  return (
    <div className={style.container} data-testid="OrgchartOrientation">
      <ToggleButton
        isOn={value === OrgChartOrientation.TopToBottom}
        onClick={() => {
          tracking.trackEvent(
            consts.TRACKING_CATEGORY.ORG_CHART,
            "orgchart_layot_ver",
            board?.documentId,
            board?.accountId,
            user?.id
          );
          onChange(OrgChartOrientation.TopToBottom);
        }}
        tooltip={"Vertical"}
        className={style.button}
      >
        {mindmapHorizontalOrientation}
      </ToggleButton>
      <ToggleButton
        isOn={value === OrgChartOrientation.LeftToRight}
        onClick={() => {
          tracking.trackEvent(
            consts.TRACKING_CATEGORY.ORG_CHART,
            "orgchart_layot_hor",
            board?.documentId,
            board?.accountId,
            user?.id
          );
          onChange(OrgChartOrientation.LeftToRight);
        }}
        tooltip={"Horizontal"}
        className={style.button}
      >
        {mindmapVerticalOrientation}
      </ToggleButton>
    </div>
  );
}
